// src/redux/slices/drawers/controlled_substance_logging/medicationConfigDrawerSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IMedicationConfigDrawerState {
    show: boolean;
    medicationId?: number;
    selectedLocationId?: number;
    newMedicationName?: string;
    isCreatingNew: boolean;
}

export const initialMedicationConfigDrawerState: IMedicationConfigDrawerState = {
    show: false,
    medicationId: undefined,
    selectedLocationId: undefined,
    isCreatingNew: false,
};

const medicationConfigDrawerSlice = createSlice({
    name: "medicationConfigDrawer",
    initialState: initialMedicationConfigDrawerState,
    reducers: {
        createNewMedication: (state) => {
            state.show = true;
            state.medicationId = undefined;
            state.selectedLocationId = undefined;
        },
        showMedicationConfigDrawer: (state, action: PayloadAction<number>) => {
            state.show = true;
            state.medicationId = action.payload;
        },
        hideMedicationConfigDrawer: (state) => {
            state.show = false;
            state.medicationId = undefined;
        },
        setMedicationConfig: (
            state,
            action: PayloadAction<Partial<IMedicationConfigDrawerState>>,
        ) => {
            return { ...state, ...action.payload };
        },
    },
});

export const {
    createNewMedication,
    showMedicationConfigDrawer,
    hideMedicationConfigDrawer,
    setMedicationConfig,
} = medicationConfigDrawerSlice.actions;

export default medicationConfigDrawerSlice.reducer;
